// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2vJp6","actionsCol":"EnrolledClinics_actionsCol__3hBdn"};